/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Time_StretchInputs */

const en_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Time Stretch`)
};

const fr_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer l’étirement du timecode`)
};

const de_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitdehnung anwenden`)
};

const it_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica Time Stretch`)
};

const ru_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примените растяжение времени`)
};

const es_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar estiramiento de tiempo`)
};

const zh_cn2_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用时间拉伸`)
};

const ja_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムストレッチを適用する`)
};

const hi_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय विस्तार लागू करें`)
};

const pt_pt2_apply_time_stretch = /** @type {(inputs: Apply_Time_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar Time Stretch`)
};

/**
* | output |
* | --- |
* | "Apply Time Stretch" |
*
* @param {Apply_Time_StretchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_time_stretch = /** @type {((inputs?: Apply_Time_StretchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Time_StretchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_time_stretch(inputs)
	if (locale === "de") return de_apply_time_stretch(inputs)
	if (locale === "it") return it_apply_time_stretch(inputs)
	if (locale === "ru") return ru_apply_time_stretch(inputs)
	if (locale === "es") return es_apply_time_stretch(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_time_stretch(inputs)
	if (locale === "ja") return ja_apply_time_stretch(inputs)
	if (locale === "hi") return hi_apply_time_stretch(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_time_stretch(inputs)
	return en_apply_time_stretch(inputs)
});